export const article = {
  id: 14,
  title: "আরোহীর সান্ধ্যগীতি",
  slug: "arohir-sandhyagiti",
  date: "December 2, 2025",
  excerpt: "প্রকৃতির মাহাত্ম্য এবং জীবনের শেষে মৃত্যুকে পরম শান্তি রূপে গ্রহণ করার এক ভাবানুবাদ।",
  content: `![Wandrers Nachtlied](https://s3.ap-south-1.amazonaws.com/sourovroy.me-content/blogs/images/arohi.png)

<div style="display: flex; justify-content: center;">
<div style="text-align: left; font-weight: bold;">

**এসেছে গোধূলি লগ্ন,**  
**পর্বতমালা সন্ন্যাসীসম; গম্ভীর ধ্যানে মগ্ন।**  
**বিদায়ী রবির প্রণতির ধারা; আলোক-স্বর্ণ বুকে—**  
**উদাসী ভূধর শান্ত, স্নিগ্ধ—উচ্ছ্বাস চোখে মুখে।**  
**মৃদু শ্বাস বায়, পাইনের গায়, আর সব যেন থেমে—**  
**মুখর পাখিরা নীরব এখন, সন্ধ্যা আসছে  নেমে।**  
**আর কিছু পথ! আমিও তাহার গেহে,**  
**আরোহন শেষে ঘুমাবো এমনি চিরশান্তির দেহে।**

</div>
</div>

আপাতদৃষ্টিতে প্রকৃতি নির্বিকার। মানুষের অস্তিত্ব নিয়ে উদাসী। তবুও সমাজ–সংসারে সে কেবলমাত্র এক প্রেক্ষাপট নয়। প্রকৃতি জীবন্ত। মানুষের নৈতিক ভালো–মন্দের বিচার প্রকৃতি করে না। তবু তার ঐশ্বরিক  উপস্থিতি সর্বক্ষনে। আর ঠিক সেখানেই তার মাহাত্ম্য। দূরে দূরে থেকেও প্রকৃতি সকলের নিকট আপন।  

জীবনের প্রতিটি পদক্ষেপে প্রকৃতি মানুষকে ঋণী করে তোলে। অবশেষে সব দেনা পরিশোধ করে নিতে মৃত্যু আসে। মানুষ আবার ফিরে যায় প্রকৃতির বুকে। যে প্রকৃতির এত নৈসর্গিক সৌন্দর্য, যার বিস্তার এত গভীর—তার অবিচ্ছেদ্দ্য অংশ হওয়া এবং অবশেষে তার বুকে মিলিয়ে যাওয়া কেবল দুঃখের ঘটনা বলে আমি মনে করি না। মানুষের জীবনকে পাহাড়ে আরোহণের সঙ্গে তুলনা করে, আরোহনের শেষে মৃত্যুকে এক পরম শান্তি রূপে গ্রহণ করাই এই লেখার মূল ভাব। 

অনেক দিন আগে জার্মান বিজ্ঞানী এবং কবি গ্যোটের "Wandrers Nachtlied II" নামক একটি কবিতা পড়েছিলাম, যার ভাব ছিল অনেকটা এমনই। বিগত ২রা ডিসেম্বর আমি যখন পায়ে হেঁটে ফালুট (পশ্চিমবঙ্গের দ্বিতীয় উচ্চতম শৃঙ্গ) পাহাড়ের চূড়ায় উঠি, উঠতে উঠতে তখন এক অবর্ণনীয় সূর্যাস্ত দেখি। সেই রাতে প্রচণ্ড ঠান্ডায় যখন ঘুম আসছিল না, তখন গ্যোটের সেই অসাধারণ লেখনীর কথা ভাবতে ভাবতেই এই লেখাটি লিখে ফেলি।

আমার জন্মের আড়াইশো বছর আগে যে পৃথিবীর মাটিতে হেঁটেছে, যার বিশ্বদর্শন আমাকে গভীরভাবে অনুপ্রাণিত করে; তাকে উৎসর্গ করে এই ভাবানুবাদ ছাড়া আর কিছু দেওয়ার নেই।`,
  author: "সৌরভ রায়",
  readTime: "৩ মিনিট পড়া",
  category: "Philosophy",
  tags: ["দর্শন", "প্রকৃতি", "কবিতা", "গ্যোটে", "মৃত্যু"],
  language: "bengali" as const
};
